export default __webpack_public_path__ + "static/media/IC00027-info.820fbdee.svg";